export default __webpack_public_path__ + "images/8c568dac4213df35f22c0fe724afcd10-nonpartisan.webp";